import "react-lazy-load-image-component/src/effects/blur.css";

import { Button, Col, Row, Space, Tag, Tooltip, Typography } from "antd";
import { removeFirstBar, removeUrlProtocol } from "../../../shared-components/Utils/Functions";

import { Description } from "../../../shared-components/Components/Property/Description/web";
import { ImagenOptimizada } from "../../../shared-components/Components/Image/web";
import { LazyLoadComponent } from "react-lazy-load-image-component";
import Link from "next/link";
import { PageLink } from "../../../shared-components/Components/Link/web";
import { PhoneButton } from "../../../shared-components/Components/RealEstateAgent/PhoneButton/web";
import React from "react";
import { Title } from "../../../shared-components/Components/Property/Title/web";
import useBreakpoint from "antd/lib/grid/hooks/useBreakpoint";
import { useTheme } from "../../../shared-components/Styles/ThemeHook";

const { Text, Paragraph } = Typography;

export const CardTopCover = ({ item }) => {
	const { img_cover, name } = item;

	return (
		<React.Fragment>
			<Col className="img-cover">
				<LazyLoadComponent>
					<ImagenOptimizada src={img_cover} alt={name} />
				</LazyLoadComponent>
			</Col>
			<CardTopExtra item={item} />
		</React.Fragment>
	);
};

export const CardTopExtra = ({ item }) => {
	const { color, logo_v2 } = item;

	const name = item?.name.split("-").join(" ");

	return (
		<React.Fragment>
			<Col className="overlay" style={{ background: color }}></Col>
			<Col className="verified ">
				<Tag color={"default"} className="verified-tag">
					{"Inmobiliaria Verificada"}
				</Tag>
			</Col>
			<Col className="inmob-logo" style={{ background: color }}>
				<LazyLoadComponent>
					<ImagenOptimizada src={logo_v2} alt={name} width="100%" />
				</LazyLoadComponent>
			</Col>
		</React.Fragment>
	);
};

export const CardContent = ({ item }) => {
	const {
		id,
		description,
		profile_url,
		inmoPropsLink,
		properties: { data },
	} = item;

	const name = item?.name.split("-").join(" ");

	const properties = data?.map(property => {
		const image = property.img;

		return {
			...property,
			pathname: "/propSingle",
			image: typeof image != "undefined" ? image : "Image",
		};
	});

	return (
		<React.Fragment>
			<Col span={24} className="perfil">
				<PageLink
					pathname="/infocasas/inmobiliarias/perfil/[perfil_id]"
					routeVars={{ perfil_id: id }}
					as={removeFirstBar(profile_url)}>
					<Button>{"Perfil Inmobiliario"}</Button>
				</PageLink>
			</Col>
			<Col span={24}>
				<Title title={name} hideInformation level={1} />
			</Col>
			<Col span={24}>
				<Description description={description} hideInformation cleanHtml />
			</Col>
			<Col span={24}>
				<div className="inmob-photos">
					{properties?.map(property => {
						return (
							<PageLink
								key={"property" + property.id}
								isExternal={property.isExternal}
								avoidRouter={false}
								pathname={property.pathname}
								data={property}
								as={property.link}>
								<LazyLoadComponent>
									<ImagenOptimizada src={property.image} alt={name} />
								</LazyLoadComponent>
							</PageLink>
						);
					})}
					{/* // Todo: Cambiar a PageLink cuando tenga el path */}
					<Link href={inmoPropsLink}>
						<a className="ant-typography" target={"_blank"}>
							<Button>{"Ver Más"}</Button>
						</a>
					</Link>
				</div>
			</Col>
			<CardBottomButtons item={item} />
		</React.Fragment>
	);
};

export const CardBottomButtons = ({ item }) => {
	const { theme } = useTheme();

	const { subsidiaries } = item;

	return (
		<Col>
			<Row gutter={theme.spacing.mdSpacing} className="property-lead-button">
				<Col flex={1} style={{ paddingBottom: 6 }}>
					<PhoneButton
						owner_id={item.id}
						owner_name={item.name}
						masked_phone={item.masked_phone}
						isWpp={false}
						ui_style="text"
					/>
				</Col>
				<Col flex={1}>
					{subsidiaries[0] ?
						<Button href={"mailto:" + subsidiaries[0]?.email} type="primary" block>
							{"Consultar"}
						</Button>
					: null}
				</Col>
			</Row>
		</Col>
	);
};

export const ItemGroupInmob = ({ item }) => {
	const screen = useBreakpoint();
	const { address, inmoPropsLink, logo, masked_phone } = item;
	const name = item?.name.split("-").join(" ");

	const LogoComponent = () => (
		<span>
			{!screen.xs && screen.sm ? (
				// Todo: Cambiar a PageLink cuando tenga el path
				<Link href={removeUrlProtocol(inmoPropsLink)}>
					<a className="ant-typography" target={"_blank"}>
						<LazyLoadComponent>
							<ImagenOptimizada
								alt={name}
								className="inmob-logo"
								src={logo}
								width="100%"
							/>
						</LazyLoadComponent>
					</a>
				</Link>
			) : (
				<LazyLoadComponent>
					<ImagenOptimizada
						alt={name}
						className="inmob-logo"
						src={logo}
						width="100%"
					/>
				</LazyLoadComponent>
			)}
		</span>
	)

	if (!address.length) {
		return LogoComponent()
	}

	return (
		<Tooltip
			color={"white"}
			placement="topLeft"
			overlayClassName="inmob-tooltip"
			title={
				<div className="inmob-tooltip-container">
					{/* // Todo: Cambiar a PageLink cuando tenga el path */}
					<Link href={removeUrlProtocol(inmoPropsLink)}>
						<a className="ant-typography" target={"_blank"}>
							<Title title={name} hideInformation level={1} />
						</a>
					</Link>
					<Space direction="vertical" className="inmob-tooltip-content">
						{/* {masked_phone && (
							<Paragraph className="view-phone">
								<Text strong className="text-phone">
									Telefono:
								</Text>
								<PhoneButton
									owner_id={item.id}
									owner_name={item.name}
									masked_phone={item.masked_phone}
									isWpp={false}
									ui_style="masked"
								/>
							</Paragraph>
						)} */}

						{address && (
							// Todo: Cambiar a PageLink cuando tenga el path
							<Link href={removeUrlProtocol(inmoPropsLink)}>
								<a className="ant-typography" target={"_blank"}>
									<Paragraph>
										<Text strong>Dirección: </Text>
										{address}
									</Paragraph>
								</a>
							</Link>
						)}
					</Space>
				</div>
			}
		>
			{LogoComponent()}
		</Tooltip>
	);
};
